import type { ContentstackPartner } from 'src/services/contentstack/types/PartnerPage.types';
import type { Image, PartnerContentState } from '../types';

export const adaptPartnerContentToStore = (
  contentstackPartner: ContentstackPartner,
): PartnerContentState => {
  const moreAboutYou = contentstackPartner.more_about_you;
  const storyImagesConnection = contentstackPartner.story_imagesConnection;

  return {
    coverImage: contentstackPartner.cover_imageConnection.edges[0]?.node.url
      ? {
          alt: contentstackPartner.cover_imageConnection.edges[0]?.node.description ?? '',
          src: contentstackPartner.cover_imageConnection.edges[0]?.node.url ?? '',
        }
      : null,
    id: Number(contentstackPartner.partner_id),
    location: contentstackPartner.location ?? '',
    logo: contentstackPartner.logoConnection.edges[0]?.node.url
      ? {
          alt: contentstackPartner.logoConnection.edges[0]?.node.description ?? '',
          src: contentstackPartner.logoConnection.edges[0]?.node.url ?? '',
        }
      : null,
    moreAboutYou: moreAboutYou
      ? {
          image: moreAboutYou.imageConnection.edges[0]?.node.url
            ? {
                alt: moreAboutYou.imageConnection.edges[0]?.node.description ?? '',
                src: moreAboutYou.imageConnection.edges[0]?.node.url ?? '',
              }
            : null,
          summary: moreAboutYou.summary ?? '',
          text: moreAboutYou.text ?? '',
          title: moreAboutYou.title ?? '',
        }
      : null,
    name: contentstackPartner.name,
    pressComments: contentstackPartner.press_comments ?? null,
    shortBrandBio: contentstackPartner.short_brand_bio ?? '',
    shortcode: contentstackPartner.shortcode,
    startDate: contentstackPartner.partner_start_date ?? '',
    storyImages: storyImagesConnection
      ? storyImagesConnection.edges
          .map((e) =>
            e.node.url
              ? {
                  alt: e.node.description ?? '',
                  src: e.node.url ?? '',
                }
              : null,
          )
          .filter((e): e is Image => e !== null)
      : null,
    storySummary: contentstackPartner.story_summary ?? '',
    storyText: contentstackPartner.story_text ?? '',
  };
};
